import { render, staticRenderFns } from "./APISettings.vue?vue&type=template&id=7e8bed09&"
import script from "./APISettings.vue?vue&type=script&lang=js&"
export * from "./APISettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports